module.exports = __webpack_public_path__ + "img/c07.3c99a35c.png";